import { useCallback } from 'react';

import { ExchangeRate } from '@store/api/types';
import { useDictionaryCurrenciesExchangeRatesQuery } from '@store/api/dictionaries.api';

import { Currency } from '@shared/enums';

export type ExchangeCurrencyResult = {
  value: number;
  from: Currency;
  to: Currency;
};

type ExchangeCurrency = (
  value: number,
  options: { from?: Currency; to: Currency; precision?: number },
) => ExchangeCurrencyResult;

export function useExchangeCurrency() {
  const { data } = useDictionaryCurrenciesExchangeRatesQuery();

  return useCallback<ExchangeCurrency>(
    (value, { from = Currency.Uah, to, precision = 0 }) => {
      const toExchangeRate =
        to === Currency.Uah ? { rate: 1 } : data?.find((item: ExchangeRate) => item.currency === to);
      const fromExchangeRate =
        from === Currency.Uah ? { rate: 1 } : data?.find((item: ExchangeRate) => item.currency === from);

      if (!toExchangeRate || !fromExchangeRate) {
        return {
          value,
          from: Currency.Uah,
          to: Currency.Uah,
        };
      }

      return {
        value: parseFloat(Number(value / (toExchangeRate.rate / fromExchangeRate.rate)).toFixed(precision)),
        from,
        to,
      };
    },
    [data],
  );
}
